import apiSlice from "./ApiSlice";

export const courseApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET COURSES
    getCourses: builder.query({
      providesTags: ["courses"],
      query: (body) => {
        return {
          url: "/course/",
          method: "POST",
          body,
        };
      },
    }),
    // ADD
    addCourse: builder.mutation({
      invalidatesTags: ["courses"],
      query: (body) => {
        return {
          url: "/course/add",
          method: "POST",
          body,
        };
      },
    }),
    // EDIT
    editCourse: builder.mutation({
      invalidatesTags: ["courses"],
      query: ({ body, id }) => {
        return {
          url: `/course/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
    // GET SINGLE COURSE
    getCourseById: builder.query({
      providesTags: ["courses"],
      query: ({ id }: { id: any }) => {
        return {
          url: `/course/${id}`,
          method: "GET",
        };
      },
    }),
    // DELETE
    deleteCourse: builder.mutation({
      invalidatesTags: ["courses"],
      query: ({ id }: { id: string }) => {
        return {
          url: `/course/${id}`,
          method: "DELETE",
        };
      },
    }),
    // ADD Plan
    addPlan: builder.mutation({
      invalidatesTags: ["courses"],
      query: (body) => {
        return {
          url: "/plan/add",
          method: "POST",
          body,
        };
      },
    }),

    //Get all Plans
    getAllPlans: builder.query({
      providesTags: ["courses"],
      query: (body: any) => {
        return {
          url: "/plan",
          method: "POST",
          body,
        };
      },
    }),
    //Get all Plans
    getPlanDurations: builder.query({
      providesTags: ["courses"],
      query: (body: any) => {
        return {
          url: "/plan",
          method: "POST",
          body,
        };
      },
    }),
    //Add class Planning Day Data
    addOneDayData: builder.mutation({
      invalidatesTags: ["courses"],
      query: ({ dayId, body }: any) => {
        return {
          url: `/plan/${dayId}/update-day-wise-planning`,
          method: "PUT",
          body,
        };
      },
    }),

    //Get all Plans without Filter Pagination
    getPlans: builder.query({
      providesTags: ["courses"],
      query: () => {
        return {
          url: "/plan",
          method: "GET",
        };
      },
    }),

    //Get all SUB course Pagination
    getSubCoursePagination: builder.query({
      providesTags: ["courses"],
      query: (body) => {
        return {
          url: "/sub-course",
          method: "POST",
          body
        };
      },
    }),

    // ADD SubCourse
    addSubCourse: builder.mutation({
      invalidatesTags: ["courses"],
      query: (body) => {
        return {
          url: "/sub-course/add",
          method: "POST",
          body,
        };
      },
    }),

    // VIEW SubCourse
    viewSingleByIdSubCourse: builder.query({
      providesTags: ["courses"],
      query: (id: any) => {
        return {
          url: `/sub-course/${id}`,
          method: "GET",
        };
      },
    }),
    //Edit
    editSubCourse: builder.mutation({
      invalidatesTags: ["courses"],
      query: ({ body, id }: any) => {
        return {
          url: `/sub-course/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
    // DELETE BY ID
    deleteSubCourse: builder.mutation({
      invalidatesTags: ["courses"],
      query: (id) => {
        return {
          url: `/sub-course/${id}`,
          method: "DELETE",
        };
      },
    }),
  }),
});

export const {
  useGetCoursesQuery,
  useAddCourseMutation,
  useEditCourseMutation,
  useGetCourseByIdQuery,
  useDeleteCourseMutation,
  useAddPlanMutation,
  useGetAllPlansQuery,
  useGetPlanDurationsQuery,
  useAddOneDayDataMutation,
  useGetPlansQuery,
  useGetSubCoursePaginationQuery,
  useAddSubCourseMutation,
  useViewSingleByIdSubCourseQuery,
  useEditSubCourseMutation,
  useDeleteSubCourseMutation
} = courseApi;
